import { useMediaQuery, useTheme, Breakpoint } from '@mui/material';

const useBreakpoint = (mode: "up" | "down" | "only" | "not", breakpoint: Breakpoint) => {
    const theme = useTheme();
    const result = useMediaQuery(theme.breakpoints[mode](breakpoint));

  return result;
}

export const useIsMobile = () => useBreakpoint("down", "sm");

export const useIsCompactLandscape = () =>
  useMediaQuery(
    "(orientation: landscape) and (max-height: 500px) and (max-width: 900px)"
  );

// True when the viewport is below the md breakpoint AND in landscape orientation.
// Used by the MyActivities + TaskDetailDialog mobile-first layouts to switch
// to the split 2-column (portrait) vs split horizontal 62/38 (landscape) variants.
export const useIsMobileLandscape = () => {
  const isSmallScreen = useBreakpoint("down", "md");
  const isLandscape = useMediaQuery("(orientation: landscape)");
  return isSmallScreen && isLandscape;
};

export default useBreakpoint;

